//Shapes.js
export const shapes = [
    'Calyx-kraters',
    'Bell-kraters',
    'Bell-krater',
    'Skyphos (frr.)',
    'Krater fragments',
    'Lekanis',
    'Pelikai',
    'Skyphoi',
    'Neck-amphora',
    'Lekanis lids',
    'Oenochoe',
    'Squat lekythos',
    'Calyx-krater',
    'Skyphoid pyxides',
    'Skyphos',
    'Skyphoid Pyxis',
    'Lekanis Lid (broken)',
    'Section of Lid',
    'Fragments',
    'Lepaste',
    'Lekanis Lid',
    'Hydria',
    'Oenochoai (shape 3)',
    'Lost Vase (Bell-krater?)',
    'Lebes Gamikos',
    'Pelike',
    'Fragments (calyx-krater)',
    'Rhyton (griffin-head)',
    'Fragment',
    'Lebetes gamikoi',
    'Hydriai',
    'Olpe',
    'Squat lekythoi',
    'Bell-krater (fragmentary)',
    'Neck-amphorae',
    'Lekanides',
    'Oenochoe (shape 3)',
    'Foot of calyx-krater',
    'Fragmentary vase',
    'Neck-amphora (with twisted handles)',
    'Ekanides',
    'Fragments (from large vases)',
    'Volute-krater',
    'Oenochoe (shape 10)',
    'Phiale',
    'Ring Askos',
    'Skyphos (of Corinthian shape)',
    'Cups',
    'Lebetes gamikoi (fragmentary)',
    'Kylikes',
    'Bell-kraters (a)',
    'Lebes gamik',
    'Oenochoai',
    'Olpe (oenochoe, shape 5)',
    'Stemless Cups',
    'Calyx-kraters (fragmentary)',
    'Bell-krater fragments',
    'Kylix',
    'Lost Vases',
    'Stemless Cup',
    'Bell-kraters (fragmentary)',
    'Lekythoi (squat)',
    'Oenochoai (shape 1)',
    'Oenochoe (shape 2)',
    'Oenochoai (shape 3 = Choes)',
    'Oenochoai (shape 6)',
    'Oenochoai (shape 10)',
    'Epichyseis',
    'Guttus',
    'Guttus (with perforated top, ring handle, and lion spout)',
    'Small fragment',
    'Lid of lebes gamikos',
    'Cup',
    'Lebes gamikos lids',
    'Oenochoe (shape 1)',
    'Fish-plates',
    'Lekythos (of special shape)',
    'Oenochoe (shape 6)',
    'Alabastra',
    'Lebetes gamikoi (lid)',
    'Plates',
    'Vacant',
    'Lekanis lids (fragmentary)',
    'Epichysis',
    'Bottle',
    'Bottles',
    'Stamnoid lebes',
    'Paestum',
    'Madrid',
    'Salerno, Mus. Prov.',
    'Lebes gamikos (fragment)',
    'Steamless Cups',
    'Lid of large lebes gamikos',
    'Plate',
    'Ring Askoi',
    'Lid of a lebes gamikos',
    'Volute-kraters',
    'Skyphos (fragment)',
    'Spouted bottle',
    'Alabastron (frr.)',
    'Lids of lebes',
    'Lids of lekanis',
    'Fragment of stemless cup',
    'Lid of skyphoid pyxis',
    'Lekythos of the Talcott class',
    'Stemmed plate',
    ]